import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { HaulersComponent } from './haulers/haulers.component';
import { HaulersEditComponent } from './haulers/haulers-edit/haulers-edit.component';
import { SigninComponent } from './auth/signin/signin.component';
import { AuthGuard } from './auth/auth-guard.service';
import { HaulersMapComponent } from './haulers/haulers-map/haulers-map.component';
import { HaulersListComponent } from './haulers/haulers-list/haulers-list.component';
import { HaulersViewComponent } from './haulers/haulers-view/haulers-view.component';

const appRoutes: Routes = [
    { path: '', redirectTo: '/haulers/map', pathMatch: 'full', canActivate: [AuthGuard]},
    { path: 'haulers', redirectTo: '/haulers/map', pathMatch: 'full', canActivate: [AuthGuard]},
    { path: 'haulers', component: HaulersComponent, canActivate: [AuthGuard], children: [
        {path: 'map', component: HaulersMapComponent, pathMatch: 'full', canActivate: [AuthGuard]},
        {path: 'list', component: HaulersListComponent, pathMatch: 'full', canActivate: [AuthGuard]}
    ]},
    { path: 'hauler', canActivate: [AuthGuard], children: [
        { path: 'new', component: HaulersEditComponent, canActivate: [AuthGuard]},
        { path: ':id', component: HaulersViewComponent, pathMatch: 'full', canActivate: [AuthGuard] },
        { path: ':id/edit', component: HaulersEditComponent, pathMatch: 'full', canActivate: [AuthGuard]}
    ]},
    { path: 'signin', component: SigninComponent}
];


@NgModule({
    imports: [RouterModule.forRoot(appRoutes)],
    exports: [RouterModule]
})


export class AppRoutingModule {

}



// WEBPACK FOOTER //
// /Users/julien/code/urbyn/urbyn-backoffice/src/app/app-routing.module.ts